import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::index
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:35
* @route '/room-blocks'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/room-blocks',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::index
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:35
* @route '/room-blocks'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::index
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:35
* @route '/room-blocks'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::index
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:35
* @route '/room-blocks'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::index
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:35
* @route '/room-blocks'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::index
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:35
* @route '/room-blocks'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::index
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:35
* @route '/room-blocks'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::store
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:81
* @route '/room-blocks'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/room-blocks',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::store
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:81
* @route '/room-blocks'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::store
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:81
* @route '/room-blocks'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::store
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:81
* @route '/room-blocks'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::store
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:81
* @route '/room-blocks'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::update
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:169
* @route '/room-blocks/{room_block}'
*/
export const update = (args: { room_block: string | number } | [room_block: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '/room-blocks/{room_block}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::update
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:169
* @route '/room-blocks/{room_block}'
*/
update.url = (args: { room_block: string | number } | [room_block: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { room_block: args }
    }

    if (Array.isArray(args)) {
        args = {
            room_block: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        room_block: args.room_block,
    }

    return update.definition.url
            .replace('{room_block}', parsedArgs.room_block.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::update
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:169
* @route '/room-blocks/{room_block}'
*/
update.put = (args: { room_block: string | number } | [room_block: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::update
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:169
* @route '/room-blocks/{room_block}'
*/
update.patch = (args: { room_block: string | number } | [room_block: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::update
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:169
* @route '/room-blocks/{room_block}'
*/
const updateForm = (args: { room_block: string | number } | [room_block: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::update
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:169
* @route '/room-blocks/{room_block}'
*/
updateForm.put = (args: { room_block: string | number } | [room_block: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::update
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:169
* @route '/room-blocks/{room_block}'
*/
updateForm.patch = (args: { room_block: string | number } | [room_block: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::destroy
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:220
* @route '/room-blocks/{room_block}'
*/
export const destroy = (args: { room_block: string | number } | [room_block: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/room-blocks/{room_block}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::destroy
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:220
* @route '/room-blocks/{room_block}'
*/
destroy.url = (args: { room_block: string | number } | [room_block: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { room_block: args }
    }

    if (Array.isArray(args)) {
        args = {
            room_block: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        room_block: args.room_block,
    }

    return destroy.definition.url
            .replace('{room_block}', parsedArgs.room_block.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::destroy
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:220
* @route '/room-blocks/{room_block}'
*/
destroy.delete = (args: { room_block: string | number } | [room_block: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::destroy
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:220
* @route '/room-blocks/{room_block}'
*/
const destroyForm = (args: { room_block: string | number } | [room_block: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\RoomBlocks\RoomBlockController::destroy
* @see app/Http/Controllers/Admin/RoomBlocks/RoomBlockController.php:220
* @route '/room-blocks/{room_block}'
*/
destroyForm.delete = (args: { room_block: string | number } | [room_block: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const roomBlocks = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default roomBlocks